import { lazyNamed } from 'src/utils/lazyNamed';
import { Advertisers } from './pages/Advertisers';
import { Campaigns } from './pages/Campaigns';
import { Creatives } from './pages/Creatives';
import { CreativesApproval } from './pages/CreativesApproval';
import { Invoicing } from './pages/Invoicing';
import { Receipts } from './pages/Receipts';
import { ScreenshotManagement } from './pages/ScreenshotManagement';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Campaigns,
  Advertisers,
  Creatives,
  CreativesApproval,
  ScreenshotManagement,
  Receipts,
  Invoicing,
};
